module.exports = __webpack_public_path__ + "static/media/tutorial-banner.e281279b.png";